import leftArrow from './leftArrow.png';
import rightArrow from './rightArrow.png';

export const icons = {
  leftArrow, // required in DatePicker @altermaind/web/ui
  rightArrow, // required in DatePicker @altermaind/web/ui
};
